<template>
  <v-card v-if="hasPermission" flat class="mb-4">
    <v-card-subtitle class="px-0 pt-0 subtitle-1 font-weight-bold">
      <v-icon left color="primary">mdi-format-list-checks</v-icon>
      Asignación de TO-DO (opcional)
    </v-card-subtitle>
    <v-divider class="mb-4"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-select
          :value="value"
          :items="availableTodos"
          :loading="loadingTodos"
          :disabled="disabled"
          item-text="name"
          item-value="id"
          label="TO-DO"
          prepend-inner-icon="mdi-format-list-checks"
          outlined
          dense
          multiple
          chips
          small-chips
          deletable-chips
          clearable
          hide-details="auto"
          hint="Selecciona las tareas a asignar al vehículo (no es obligatorio)"
          persistent-hint
          @input="$emit('input', $event)"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip
              v-if="index < 3"
              :color="item.button_color"
              :text-color="item.text_color"
              small
              close
              @click:close="removeTodo(item)"
            >
              <v-avatar left :color="item.button_color" class="darken-1" style="display: flex; align-items: center; justify-content: center;">
                <span :style="{ color: item.text_color }" style="font-size: 12px; font-weight: bold;">{{ getInitial(item.name) }}</span>
              </v-avatar>
              {{ item.name }}
            </v-chip>
            <span
              v-if="index === 3"
              class="grey--text text-caption"
            >
              (+{{ value.length - 3 }} más)
            </span>
          </template>
        </v-select>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import TodoCategoryService from '@/services/TodoCategoryService'

export default {
  name: 'TodoAssignmentBox',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      availableTodos: [],
      loadingTodos: false
    }
  },
  computed: {
    hasPermission () {
      const hasPermission = this.$store.getters.HAS_PERMISSION
      return typeof hasPermission === 'function' ? hasPermission('asignar_todo') : true
    }
  },
  async created () {
    if (this.hasPermission) {
      await this.loadAvailableTodos()
    }
  },
  methods: {
    getInitial (name) {
      return name ? name.charAt(0).toUpperCase() : '?'
    },
    removeTodo (item) {
      const updated = this.value.filter(id => id !== item.id)
      this.$emit('input', updated)
    },
    async loadAvailableTodos () {
      this.loadingTodos = true
      try {
        const response = await TodoCategoryService.get()
        if (response.data && response.data.data && response.data.data.data) {
          this.availableTodos = response.data.data.data
        } else if (response.data && response.data.data) {
          this.availableTodos = response.data.data
        } else if (response.data) {
          this.availableTodos = response.data
        }
      } catch (error) {
        console.error('Error al cargar TO-DO:', error)
      } finally {
        this.loadingTodos = false
      }
    }
  }
}
</script>
